import BeritaContent from "../../modules/berita/component/BeritaContent";

import React from "react";

const Berita: React.FC = () => {
  return (
    <div>
      <BeritaContent />
    </div>
  );
};

export default Berita;
